import React, { useEffect, useRef, useState } from 'react';
import { DispenseStatementFilterOption, DispenseStatementPageLabels, PillPackComFilterOption } from "../component";
import { getDispenseStatementPage } from "../../accessors/GraphQLAccessor";
import DispenseStatementBottomSheetContent from "./DispenseStatementBottomSheetContent";
import { StatementStatus } from "../common/utils/DocumentFetchUtils";

interface DispenseStatementBottomSheetProps {
    getMedicationOrderStatements: string,
    iosDevice?: boolean,
    androidDevice?: boolean,
    mShop?: boolean
    spaceTopCssProps?: string;
}



export interface AbortDownload {
    abortController: AbortController | undefined;
    reason: string | undefined;
}

const abortDownload: AbortDownload = { abortController: undefined, reason: undefined };

function DispenseStatementBottomSheet(props: DispenseStatementBottomSheetProps) {
    const [labels, setLabels] = useState<DispenseStatementPageLabels>();
    const [filterOptions, setFilterOptions] = useState<DispenseStatementFilterOption[]>();
    const [pillPackComFilterOptions, setPillPackComFilterOptions] = useState<PillPackComFilterOption[]>();
    const [statementStatus, setStatementStatus] = useState<StatementStatus>(StatementStatus.Hidden);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const bottomSheetRef = useRef<any>(null);
    const [pillPackComMigrationStatus, setPillPackComMigrationStatus] =
        useState<string>("");

    const showBottomSheet = async () => {
        if (!labels || !filterOptions) {
            setIsLoading(true);
            try {
                const response = await getDispenseStatementPage();
                setLabels(response.data.dispenseStatementPage.labels);
                setFilterOptions(response.data.dispenseStatementPage.filterOptions);
                setPillPackComFilterOptions(response.data.dispenseStatementPage.pillPackComFilterOptions);
                setPillPackComMigrationStatus(response.data.dispenseStatementPage.pillPackComMigrationResponse);
            } catch (error) {
                return;
            } finally {
                setIsLoading(false);
            }
        }
        setStatementStatus(StatementStatus.FilterOptions);
        bottomSheetRef?.current?.show();
    }

    const hideBottomSheet = () => {
        bottomSheetRef?.current?.hide();
    }

    const abort = (reason: string) => {
        if (abortDownload.abortController) {
            abortDownload.reason = reason;
            abortDownload.abortController.abort();
        }
    }

    const handleHideBottomSheet = async () => {
        abort("hide");
    }

    useEffect(() => {
        const current = bottomSheetRef.current;
        if (bottomSheetRef && bottomSheetRef.current) {
            current.addEventListener('hideBottomSheet', handleHideBottomSheet);
            return () => {
                current.removeEventListener('hideBottomSheet', handleHideBottomSheet)
            }
        }
    })

    return (<>
        <pui-link
            id="link-to-ingress-into-dispense-statement"
            data-csa-c-type="link"
            data-csa-c-action="paginate"
            data-csa-c-content-id="link-to-ingress-into-dispense-statement"
            data-csa-c-slot-id="dispense-statement"
            spacingTop={props.spaceTopCssProps ? props.spaceTopCssProps : 'small'}
            text={props.getMedicationOrderStatements}
            onClick={showBottomSheet}
            disabled={isLoading}
        />
        {(labels && filterOptions) && (
            <pui-bottom-sheet disableModalPadding enablescrollbar id="dispense-statement-modal" data-csa-c-content-id="dispense-statement-modal" data-csa-c-type="popup" data-csa-c-slot-id="order-history" ref={bottomSheetRef} >
                <DispenseStatementBottomSheetContent
                    labels={labels}
                    filterOptions={filterOptions}
                    pillPackComFilterOptions={pillPackComFilterOptions}
                    pillPackComMigrationStatus={pillPackComMigrationStatus}
                    showBottomSheet={showBottomSheet}
                    hideBottomSheet={hideBottomSheet}
                    abortDownload={abortDownload}
                    setStatementStatus={setStatementStatus}
                    statementStatus={statementStatus}
                    iosDevice={props.iosDevice ?? false}
                    androidDevice={props.androidDevice ?? false}
                    mShop={props.mShop ?? false}
                />
            </pui-bottom-sheet>
        )}
    </>);
}

export default DispenseStatementBottomSheet;